import { docReady } from './utils.js';
import plyrInit from './plyr.js';
import initMap from './googleMap.js';
import swiperInit from './swiper.js';
import tooltipInit from './tooltip.js';
import popoverInit from './popover.js';
import typedTextInit from './typed.js';
import progressBarInit from './progressbar.js';
import rellaxInit from './rellax.js';
import countupInit from './countup.js';
import isotopeInit from './isotope.js';
import zanimationInit from './zanimation.js';
import fancyNavInit from './fancynav.js';
import drawSvgInit from './drawsvg.js';
import preloaderInit from './preloader.js';
import bgPlayerInit from './bg-player.js';
import countdownInit from './countdown.js';
import lightboxInit from './lightbox.js';
import cookieNoticeInit from './notice.js';
import bootstrapNavbarInit from './bootstrap-navbar.js';


/* -------------------------------------------------------------------------- */
/*                            Theme Initialization                            */
/* -------------------------------------------------------------------------- */

docReady(fancyNavInit);
docReady(countdownInit);
docReady(plyrInit);
docReady(initMap);
docReady(tooltipInit);
docReady(popoverInit);
docReady(typedTextInit);
docReady(progressBarInit);
docReady(rellaxInit);
docReady(countupInit);
docReady(isotopeInit);
docReady(zanimationInit);
docReady(swiperInit);
docReady(drawSvgInit);
docReady(bgPlayerInit);
docReady(lightboxInit);
docReady(cookieNoticeInit);
docReady(bootstrapNavbarInit);
docReady(preloaderInit);


